

















import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { RectangleLayer } from "@/model/document2/page/surface/design/layer/rectangleLayer";
import { CircleLayer } from "@/model/document2/page/surface/design/layer/circleLayer";
import { PolygonLayer } from "@/model/document2/page/surface/design/layer/polygonLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class PatternOpacityController extends Vue 
{
    @Prop() layer! : RectangleLayer | CircleLayer | PolygonLayer;

    private get opacity()
    {
        return this.layer.opacity;
    }

    private set opacity(opacity)
    {
        this.changeLayerProperty("opacity", Number(opacity), false, false);
    }

    private get opacityText()
    {
        return this.layer.opacity.toFixed() + "%";
    }

    private onOpacityChanged()
    {
        this.changeLayerProperty("opacity", this.layer.opacity, true, false);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
